var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlogImageFallback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 96,
    viewBox: "0 0 185 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 96,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.105 36.723C110.058 36.723 107.588 34.3352 107.588 31.3896C107.588 28.4441 110.058 26.0563 113.105 26.0563C116.152 26.0563 118.622 28.4441 118.622 31.3896C118.622 34.3352 116.152 36.723 113.105 36.723Z",
    fill: "#CAC8CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.1674 80H125.833C129.235 80 132 77.3212 132 74.0281V21.9719C132 18.677 129.233 16 125.833 16H58.1674C54.7665 16 52 18.6788 52 21.9719V74.0281C52 77.3212 54.7665 80 58.1674 80ZM125.833 18.8651C126.683 18.866 127.499 19.1936 128.1 19.7761C128.702 20.3585 129.04 21.1482 129.041 21.9719V62.2271L114.009 48.3756C112.129 46.6431 109.203 46.5528 107.212 48.1658L95.6392 57.5437L80.1522 39.4777C78.1151 37.1014 74.3462 37.0972 72.3035 39.469L54.9589 59.6075V21.9719C54.9598 21.1482 55.2982 20.3585 55.8997 19.7761C56.5012 19.1936 57.3167 18.866 58.1674 18.8651H125.833Z",
    fill: "#CAC8CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogImageFallback);
export default __webpack_public_path__ + "static/media/blog-image-fallback.bbeee689085c62d6b9108c8ae0848512.svg";
export { ForwardRef as ReactComponent };